export default "__VITE_ASSET__CCDlXVPk__"